import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { getDirectLoginToken } from './login-index.reducer';
import { flatMap } from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(
    private store: Store<any>
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return this.store.pipe(
      select(getDirectLoginToken),
      first(),
      flatMap(token => {
        const authReq =
        (!!token && request.url.indexOf('/amadeus/') !== -1 && request.url.indexOf('/public/') === -1) ||
        request.url.indexOf('Task') !== -1
          ? request.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
          : request;
        return next.handle(authReq);
      })
    );
  }
}
